var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFourGrids(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9585 4.79159C3.9585 4.33135 4.33159 3.95825 4.79183 3.95825H7.7085C8.16873 3.95825 8.54183 4.33135 8.54183 4.79159V7.70825C8.54183 8.16849 8.16873 8.54159 7.7085 8.54159H4.79183C4.33159 8.54159 3.9585 8.16849 3.9585 7.70825V4.79159Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9585 12.2916C3.9585 11.8313 4.33159 11.4583 4.79183 11.4583H7.7085C8.16873 11.4583 8.54183 11.8313 8.54183 12.2916V15.2083C8.54183 15.6685 8.16873 16.0416 7.7085 16.0416H4.79183C4.33159 16.0416 3.9585 15.6685 3.9585 15.2083V12.2916Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4585 4.79159C11.4585 4.33135 11.8316 3.95825 12.2918 3.95825H15.2085C15.6687 3.95825 16.0418 4.33135 16.0418 4.79159V7.70825C16.0418 8.16849 15.6687 8.54159 15.2085 8.54159H12.2918C11.8316 8.54159 11.4585 8.16849 11.4585 7.70825V4.79159Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4585 12.2916C11.4585 11.8313 11.8316 11.4583 12.2918 11.4583H15.2085C15.6687 11.4583 16.0418 11.8313 16.0418 12.2916V15.2083C16.0418 15.6685 15.6687 16.0416 15.2085 16.0416H12.2918C11.8316 16.0416 11.4585 15.6685 11.4585 15.2083V12.2916Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFourGrids);
export default __webpack_public_path__ + "static/media/four-grids.d7bc480fdd845004fc69ab7b3f755dbf.svg";
export { ForwardRef as ReactComponent };